import { Alert, Button, Stack } from "@mantine/core";
import { useState } from "react";
import { Link } from "react-router-dom";
import { AddCandidateForm } from "../components/AddCandidateForm";
import { PageHeader } from "../components/ui";
import { NAV_COPY, NAV_ICONS } from "../lib/navCopy";
import { axioTokens } from "../theme";

export function AddCandidatePage() {
  const [done, setDone] = useState(false);

  return (
    <Stack gap={axioTokens.unit[32]} maw="var(--axio-unit-820)">
      <PageHeader
        icon={NAV_ICONS.addCandidate}
        title={NAV_COPY.recruiter.addCandidate}
        subtitle="Upload a resume — we fill everything in. You just review and confirm."
      />

      {done ? (
        <Alert color="green" title="Candidate added — you can close this tab">
          This candidate is in your pool. You can close this tab and keep working from the list, or add
          another.
        </Alert>
      ) : (
        <AddCandidateForm onSuccess={() => setDone(true)} />
      )}

      {done && (
        <Button component={Link} to="/candidates" variant="default" w="fit-content">
          Back to my candidates
        </Button>
      )}
    </Stack>
  );
}
